<app-page-header></app-page-header>
<app-breadcromb pageName="Browse Application"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-12 dashboard-left-border">
        <div class="dashboard-left">
          <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="dashboard-right">
          <div class="candidate-profile">
            <div class="candidate-single-profile-info">
              <div class="single-candidate-widget">
                <button class="btn btn-sm btn-info" (click)="backToMyApplications()">Back to applications</button>
              </div>
              <app-job-description [vacancy]="vacancy"></app-job-description>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Candidate Dashboard Area End -->
